import { Component, Input, Output, ViewChild, TemplateRef, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';


@Component({
    selector: 'my-modal',
    templateUrl: 'modal.component.html',
    styleUrls: ['modal.component.scss']
})
export class ModalComponent {

    @Input() hideDefaultButton = false;
    @Input() useCustomFooter = false;
    @Input() showCancel = false;
    @Input() lpRequest: false;
    @Input() hideFooter: false;
    @Input() borrowerId: string;
    @Input() theme = 'ls2';
    @Input() classes: string[];

    @ViewChild('template', { static: true }) template: TemplateRef<any>;

    @Output() hideModal = new EventEmitter<any>();

    modalRef: BsModalRef|null;

    constructor(private modalService: BsModalService) {
        this.modalService.onHide
            .pipe()
            .subscribe(() => {
                this.hideModal.emit();
            });
    }

    hide() {
        if (this.modalRef) {
            this.modalRef.hide();
            this.modalRef = null;
        }
    }

    show() {
        this.modalRef = this.modalService.show(this.template, { class: [this.theme].concat(this.classes).join(' ') });
    }
}

